<template>
  <span>
    <button
        v-for="level in headingLevels"
        :key="'heading-button'+level"
        type="button"
        class="
                btn
                btn-default
                p-2
                leading-none
                text-xs
                min-w-8
                h-8
                tiptap-button
            "
        :class="{ 'btn-primary': editor.isActive('heading', {level: level}) }"
        @click="editor.chain().focus().toggleHeading({'level': level}).run()"
    >
      H{{ level }}
    </button>
  </span>
</template>

<script>
// https://tiptap.dev/api/nodes/heading
export default {
  props: ['headingLevels', 'editor', 'commands'],
}
</script>



